import Api from './Api'
export default { 
  contactUs(name, email, message){
    const data = new FormData();
    data.append('name', name);
    data.append('email', email);
    data.append('message', message);
    return Api().post('/email', data)
  },
}
